import type { FieldValueMappings } from 'pages/AutomationEngine/types';
import type { FieldsToModify } from './types';
import UUID from 'utility/UUID';

export const recordSourceOptionsConst = {
  RELATED_OBJECT_FIELD: 'related_object_field',
  AUTOMATION_VARIABLE: 'automation_variable',
} as const;

export type RecordSourceOption = ValueOf<typeof recordSourceOptionsConst>;

export const mreChangeTypeOptionsConst = {
  SPECIFIC_VALUE: 'specific_value',
  RELATED_OBJECT_FIELD: 'context_entity_value',
  VARIABLE: 'variable',
  ENTITY_VARIABLE_FIELD: 'entity_variable_field',
  BLANK_VALUE: 'blank',
} as const;

export type MreChangeTypeOptions = ValueOf<typeof mreChangeTypeOptionsConst>;

export const isValueTypeRelated = (ftm: FieldsToModify) =>
  ftm?.valueType?.value === mreChangeTypeOptionsConst.RELATED_OBJECT_FIELD;

export const isValueTypeEntityVariableField = (ftm: FieldsToModify) =>
  ftm?.valueType?.value === mreChangeTypeOptionsConst.ENTITY_VARIABLE_FIELD;

export const inputsModifyRelatedEntities = {
  RECORD_SOURCE: 'recordSource',
  RECORD_SOURCE_VARIABLES: 'recordSourceVariables',
  OBJECT_TO_MODIFY: 'objectToModify',
  AUTOMATION_TARGET_RELATIONSHIP_FIELDS: 'automationTargetRelationshipFields',
  FIELDS_TO_MODIFY: 'fieldsToModify',
  ADD_FIELD_TO_MODIFY: 'addFieldToModify',
  DELETE_FIELD_TO_MODIFY: 'deleteFieldToModify',
  UPDATE_TYPE: 'updateType',
} as const;

export type InputsModifyRelatedEntities = ValueOf<
  typeof inputsModifyRelatedEntities
>;

export const newFieldValueMappings = (order: number): FieldValueMappings => ({
  key: UUID.generate(),
  sourceValues: null,
  targetValues: null,
  order,
});

export const fieldResolutionOptionsConst = {
  OVERWRITE: 'overwrite',
  ONLY_UPDATE_BLANK: 'update_if_blank',
  ONLY_ADD_OPTIONS: 'add_only',
} as const;

export type FieldResolutionOptions = ValueOf<
  typeof fieldResolutionOptionsConst
>;
